import * as THREE from 'three';
import type { GameplayUnitAnimator, UnitAnimator } from './unit-animator.js';
import { ShadowReach } from '../shadow-reach.js';

export function needsUnitPose(inView: boolean, dead: boolean, animator: Pick<UnitAnimator, 'deathState' | 'settledCorpse'> & Partial<Pick<GameplayUnitAnimator, 'proneState'>>) {
  return inView || animator.deathState === 'falling' || animator.proneState === 'falling' || dead && !animator.settledCorpse;
}

/** Pose/matrix work is needed for camera draws and for off-screen figures whose shadows reach the view. */
export class UnitViewCulling {
  private reach = new ShadowReach();

  update(camera: THREE.Camera, sun?: THREE.DirectionalLight) { this.reach.update(camera, sun); }

  visible(position: { x: number; y: number; z: number }, height: number, radius = .5) {
    // Include lunges, equipment and fallen poses without touching the skeleton's matrices.
    return this.reach.figure(position, height + 1, height / 2 + radius + 1);
  }
}
